import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import type { Breadcrumb } from '../../lib/registries';

export interface BreadcrumbsProps {
  items: Breadcrumb[];
}

// Breadcrumbs (D44, story 2-104) — the crumb trail for a `resolveBreadcrumbs`
// result (lib/registries): the same registry/capability pass that drives the
// sidebar's active state, so a crumb never names a route the principal
// couldn't also reach from the nav. Renders nothing for an empty trail
// (dashboard root, or a route the registry doesn't know) rather than a bare
// "Dashboard" crumb.
export function Breadcrumbs({ items }: BreadcrumbsProps): JSX.Element | null {
  if (items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className="text-sm">
      <ol className="flex flex-wrap items-center gap-1 text-muted-foreground">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-1">
            {index > 0 && <ChevronRightIcon className="h-3.5 w-3.5 shrink-0" aria-hidden />}
            {item.current || !item.to ? (
              <span aria-current={item.current ? 'page' : undefined} className="font-medium text-foreground">
                {item.label}
              </span>
            ) : (
              <Link to={item.to} className="focus-ring rounded px-0.5 transition hover:text-foreground">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
